import { render, staticRenderFns } from "./EquipmentTabs.vue?vue&type=template&id=c83c95fc"
import script from "./EquipmentTabs.vue?vue&type=script&lang=js"
export * from "./EquipmentTabs.vue?vue&type=script&lang=js"
import style0 from "./EquipmentTabs.vue?vue&type=style&index=0&id=c83c95fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports